import React from "react";
import { Form } from "react-bootstrap";

export default function AIWizardField(props) {
    return (
        <Form.Control as="textarea" maxLength={5000} rows={3} value={props.value} onChange={(e) => props.setValue(e.target.value, props.field.apiKeyName)}></Form.Control>
    )
}